import { render, staticRenderFns } from "./ExpandText.vue?vue&type=template&id=7309391b&scoped=true"
import script from "./ExpandText.vue?vue&type=script&lang=js"
export * from "./ExpandText.vue?vue&type=script&lang=js"
import style0 from "./ExpandText.vue?vue&type=style&index=0&id=7309391b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7309391b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7309391b')) {
      api.createRecord('7309391b', component.options)
    } else {
      api.reload('7309391b', component.options)
    }
    module.hot.accept("./ExpandText.vue?vue&type=template&id=7309391b&scoped=true", function () {
      api.rerender('7309391b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/ExpandText.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ExpandText.vue
// module id = 112
// module chunks = 0